import {dataPostRequest, getRequest} from "../../utils/request";

export const listQuickNotes = ()=>{
  return getRequest('/quickNote/all');
}

export const addQuickNote = (data)=>{
  return dataPostRequest('/quickNote/add',data);
}

export const updateQuickNote = (data)=>{
  return dataPostRequest('/quickNote/update',data);
}

export const deleteQuickNote = (id)=>{
  return getRequest('/quickNote/delete/' + id);
}



// WEBPACK FOOTER //
// ./src/api/task/quickNote.js